// extracted by mini-css-extract-plugin
export default {"helperMessage":"ConflictResolutionMessage_helperMessage__DniA+","list":"ConflictResolutionMessage_list__yra6d"};